<edp-public-header *ngIf="!clearHeader"></edp-public-header>
<edp-public-header-clear *ngIf="clearHeader"></edp-public-header-clear>
<router-outlet></router-outlet>
<edp-footer></edp-footer>
